// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N665","left":"styles_left__2jF6M"};